import expandOrContractRangeByLength from "./expandOrContractRangeByLength";
import isRangeWithinRange from "./isRangeWithinRange";
import getOverlapsOfPotentiallyCircularRanges from "./getOverlapsOfPotentiallyCircularRanges";
import translateRange from "./translateRange";
import getRangeLength from "./getRangeLength";
export default function flipRelativeRange(innerRange, outerRange, sequenceLength) {
  const isFullyContained = isRangeWithinRange(
    innerRange,
    outerRange,
    sequenceLength
  );
  if (isFullyContained) {
    return flipFullyContainedRange(innerRange, outerRange, sequenceLength);
  } else {
    return flipNonFullyContainedRange(innerRange, outerRange, sequenceLength);
  }
}
function flipNonFullyContainedRange(innerRange, outerRange, sequenceLength) {
  const outerFullyContained = isRangeWithinRange(
    outerRange,
    innerRange,
    sequenceLength
  );
  let flippedInnerRange;
  if (outerFullyContained) {
    const expandBy1 = getRangeLength(
      {
        start: innerRange.start,
        end: outerRange.start
      },
      sequenceLength
    ) - 1;
    flippedInnerRange = expandOrContractRangeByLength(
      outerRange,
      expandBy1,
      false,
      sequenceLength
    );
    const expandBy2 = getRangeLength(
      {
        end: innerRange.end,
        start: outerRange.end
      },
      sequenceLength
    ) - 1;
    flippedInnerRange = expandOrContractRangeByLength(
      flippedInnerRange,
      expandBy2,
      true,
      sequenceLength
    );
  } else {
    const overlaps = getOverlapsOfPotentiallyCircularRanges(
      innerRange,
      outerRange,
      sequenceLength
    );
    if (overlaps.length >= 1) {
      const firstOverlap = overlaps[0];
      const overlapExtendsForward = firstOverlap.start !== outerRange.start;
      const flippedTruncatedInner = flipFullyContainedRange(
        firstOverlap,
        outerRange,
        sequenceLength
      );
      const lengthToExtend = getRangeLength(innerRange, sequenceLength) - getRangeLength(flippedTruncatedInner, sequenceLength);
      flippedInnerRange = expandOrContractRangeByLength(
        flippedTruncatedInner,
        lengthToExtend,
        overlapExtendsForward,
        sequenceLength
      );
    } else {
      throw new Error(
        "This case (relative ranges that do not overlap) is unsupported! "
      );
    }
  }
  return flippedInnerRange;
}
function flipFullyContainedRange(innerRange, outerRange, sequenceLength) {
  const translateBy = -outerRange.start;
  const translatedOuterRange = translateRange(
    outerRange,
    translateBy,
    sequenceLength
  );
  const translatedInnerRange = translateRange(
    innerRange,
    translateBy,
    sequenceLength
  );
  const translatedFlippedInnerRange = flipNonOriginSpanningContainedRange(
    translatedInnerRange,
    translatedOuterRange,
    sequenceLength
  );
  const flippedInnerRange = translateRange(
    translatedFlippedInnerRange,
    -translateBy,
    sequenceLength
  );
  return flippedInnerRange;
}
function flipNonOriginSpanningContainedRange(innerRange, outerRange, sequenceLength) {
  const offsetFromStart = innerRange.start - outerRange.start;
  const newInnerEnd = outerRange.end - offsetFromStart;
  const innerRangeLength = getRangeLength(innerRange, sequenceLength);
  return {
    end: newInnerEnd,
    start: newInnerEnd - (innerRangeLength - 1)
  };
}
